(() => {
  // Re-runnable: re-queries the DOM and restarts the animation from 0 on each call.
  function initOrderByReceiveBy() {
    const container = document.querySelector(".order-by-receive-by");
    if (!container) return;

    const track = container.querySelector(".orb-bar");
    const fill = container.querySelector(".orb-fill");
    const icon = container.querySelector(".orb-progress-icon");
    const middle = container.querySelector(".orb-middle");
    const last = container.querySelector(".orb-last");

    const DURATION = 5000;
    const prefersReduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    // Apply a single progress value (0..1) to bar, icon and text colors
    function render(progress) {
      const width = track.getBoundingClientRect().width;
      const x = progress * width;

      fill.style.width = progress * 100 + "%";
      icon.style.left = x + "px";

      const containerLeft = track.getBoundingClientRect().left;
      const middleX = middle.getBoundingClientRect().left - containerLeft;
      const lastX = last.getBoundingClientRect().left - containerLeft;

      middle.classList.toggle("orb-active", x >= middleX);
      last.classList.toggle("orb-active", x >= lastX);
    }

    if (prefersReduced) {
      render(1);
      return;
    }

    let start = null;
    function step(timestamp) {
      if (start === null) start = timestamp;
      const progress = Math.min((timestamp - start) / DURATION, 1);

      render(progress);

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  }

  // Exposed globally in case it needs to be re-triggered elsewhere (e.g. after a variant swap).
  window.initOrderByReceiveBy = initOrderByReceiveBy;
  initOrderByReceiveBy();
})();
